import { render, staticRenderFns } from "./task_unsaved_dialog.vue?vue&type=template&id=106d43e8&scoped=true"
import script from "./task_unsaved_dialog.vue?vue&type=script&lang=js"
export * from "./task_unsaved_dialog.vue?vue&type=script&lang=js"
import style0 from "./task_unsaved_dialog.vue?vue&type=style&index=0&id=106d43e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106d43e8",
  null
  
)

export default component.exports